import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { AnchorDirective, DealerFeature, RouterLinkDirective, WarrantyPageFeature } from '@hyundai/ng-common-lib';
import { M000C010ImageComponent, M030C130WarrentyListComponent, M040C020TeaserAllrounderComponent } from '@hyundai/ui';
import { Store } from '@ngrx/store';
import { GlobalContactComponent } from '../../components/global-contact/global-contact.component';

@Component({
    selector: 'app-warranty-page',
    standalone: true,
    imports: [
        RouterLinkDirective,
        AnchorDirective,
        M000C010ImageComponent,
        GlobalContactComponent,
        M030C130WarrentyListComponent,
        M040C020TeaserAllrounderComponent,
    ],
    templateUrl: './warranty-page.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarrantyPageComponent {
    store = inject(Store);
    dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);
    dealerContactMailLink = this.store.selectSignal(DealerFeature.state.selectDealerContactFormUrl);
    locationHeadline = this.store.selectSignal(DealerFeature.state.selectDealerLocationHeadline);
    content = this.store.selectSignal(WarrantyPageFeature.state.selectLoadedContent);
}
